/**
 * Property Details Controller
 */
bookingApp.controller('propertyDetailsController',function($scope, sessionFactory, propertyFactory, appFactory, $http, $filter, $routeParams){
    $scope.session = sessionFactory;
    $scope.property = propertyFactory;
    $scope.baseApp = appFactory;
    $scope.baseApp.controls.type = 'back';

    // setup the footer controls
    $scope.footer.display.prev = false;
    $scope.footer.display.next = false;
    $scope.footer.mainContent = '<span class="glyphicon glyphicon-chevron-left"></span> Back';
    $scope.footer.mainFunc = function(){
        $scope.goBack();
    };

    $scope.carouselPhotos = [];

    $scope.getPropertyPhotos = function(){
        for(var photo in $scope.property.photos){
            if($scope.property.photos.hasOwnProperty(photo)){
                photoUrl = $scope.property.photos[photo].transformedUrl ? $scope.property.photos[photo].transformedUrl : $scope.property.photos[photo].url
                $scope.carouselPhotos.push(photoUrl);
            }
        }
    };

    $scope.getPropertyDetails = function(){
        // show the loader
        $scope.session.isLoading = true;
        $http.get('/front-booking/api-property-details/',{
            params: {
                bc: $scope.property.id,
                sid: $scope.session.sid,
                templateID: $scope.property.template.id,
                format: 'json'
            }
        })
        .success(function(data, status, headers, config){
                // property details
                $scope.property.description = data.description;
                $scope.property.checkinTime = data.checkinTime;
                $scope.property.checkoutTime = data.checkoutTime;
                $scope.property.receptionHours = data.receptionHours;
                $scope.property.directionsToProperty = data.directionsToProperty;
                $scope.property.additionalInfo = data.additionalInfo;
                $scope.property.facilities = data.propertyFacilities;
                $scope.property.roomFacilities = data.generalRoomFacilities;
                $scope.property.parking = data.parking;
                $scope.property.distances = data.distances;
                $scope.property.directions = data.directions;
                $scope.property.map = data.propertyMap;
                $scope.property.mapLink = data.propertyMapLink;
                $scope.property.photos = data.propertyPhotos.photos;
                // sort photos correctly
                if(typeof data.propertyPhotos.locationMapPhotoIndex === "number") {
                    var mapPhoto = $scope.property.photos.splice(data.propertyPhotos.locationMapPhotoIndex, 1);
                    $scope.property.photos = $scope.property.photos.concat(mapPhoto);
                }

                // property policies
                $scope.property.paymentPolicy = data.paymentPolicy;
                $scope.property.cancellationPolicy = data.cancellationPolicy;
                $scope.property.childPolicy = data.childPolicy;
                $scope.property.checkinPolicy = data.checkinPolicy;

                $scope.getPropertyPhotos();

                // hide the loader
                $scope.session.isLoading = false;
        })
        .error(function(data, status, headers, config){
            // display error to the user
            // hide the loader
            $scope.session.isLoading = false;
        });
    }
});
